import SearchServices from './selectSearch.services';
import * as actions from './actionsTypes';
import errorManage from '../errorManage';

export const getSelectSearch = (endpoint, params) => async (dispatch) => {
  try {
    dispatch({
      type: actions.IS_LOADING_SEARCH,
      payload: true
    });
    const resp = await SearchServices.getSelectSearch(endpoint, params);
    dispatch({ 
      type: actions.GET_SEARCH, 
      payload: {data: resp.data.data, recordsCount: resp.data.count}});
  } catch (error) {
    errorManage(error, dispatch, actions.FAIL_SEARCH);
  }finally {
    dispatch({
      type: actions.IS_LOADING_SEARCH,
      payload: false
    });
  }
}